import * as React from "react";
import { MetaTags } from "../../../head";

const Terms = () => [
  <MetaTags key={0} title="Điều khoản sử dụng" />,
  <div key={1} className="tab-pane active">
    <h1>Điều khoản sử dụng của Express Design</h1>
    <p>
      <em>Cập nhật: Ngày 13 tháng 07 năm 2017</em>
    </p>
    <h3>Chào mừng bạn đến với Express Design</h3>
    <p>
      Chào mừng bạn đến với Dịch vụ ExpressDesign.vn, Dịch vụ được cung cấp bởi
      Công ty TNHH Thiết Kế Hỏa Tốc (“Express Design”, “ExpressDesign”, “ED”,
      “chúng tôi”, “đội ngũ phát triển”).
    </p>
    <p>
      Thông qua việc truy cập, duyệt nội dung, hình ảnh hoặc sử dụng bất kì nội
      dung, hình ảnh nào của trang thông tin điện tử này, bạn (“Người sử dụng”)
      đang đồng ý với các điều khoản này. Chúng tôi mong bạn vui lòng dành thời
      gian đọc và tìm hiểu những điều khoản về thỏa thuận pháp lý giữa bạn và ED
      như dưới đây.
    </p>
    <p>
      ED chịu trách nhiệm đảm bảo tính hợp pháp của việc cung cấp dịch vụ trên
      website đến người sử dụng. Mọi thông tin, hình ảnh và toàn bộ nội dung
      được đăng tải và gửi tới người sử dụng trên website tuân thủ các quy định
      của pháp luật, và phù hợp với thuần phong mỹ tục Việt Nam.
    </p>
    <p>
      Dịch vụ của chúng tôi đôi khi có thể áp dụng các điều khoản bổ sung hoặc
      các yêu cầu về sản phẩm. Các điều khoản bổ sung sẽ được cung cấp kèm theo
      Dịch vụ liên quan và các điều khoản bổ sung đó sẽ trở thành một phần thuộc
      thỏa thuận của bạn với chúng tôi nếu bạn sử dụng các Dịch vụ đó.
    </p>
    <p>
      <b>Giải thích các thuật ngữ:</b>
    </p>
    <ul>
      <li>
        <b>“Express Design”:</b> Công ty TNHH Thiết Kế Hỏa Tốc.
      </li>
      <li>
        <b>“ED”</b>: Tên viết tắt của Công ty TNHH Thiết Kế Hỏa Tốc trong văn
        bản
      </li>
      <li>
        <b>“Dịch vụ”</b>: Người sử dụng sử dụng các sản phẩm, dịch vụ thiết kế
        và trang web của Express Design
      </li>
      <li>
        <b>“Người sử dụng”</b>: Những cá nhân, tổ chức, hoặc bất kỳ ai truy cập
        và sử dụng trang Website của Express Design dưới mọi hình thức.
      </li>
      <li>
        <b>“Website”</b>: Trang web của Express Design (expressdesign.vn).
      </li>
      <li>
        <b>“Điều khoản sử dụng”</b>: Những điều kiện và điểu khoản mà Người sử
        dụng truy cập và sử dụng Website phải tuân thủ và thực hiện khi sử dụng
        dịch vụ của Express Design. Người sử dụng sử dụng Website được mặc nhiên
        hiểu rằng đã đọc,hiểu rõ, đồng ý và cam kết thực hiện đúng những quy
        định sử dụng của Website tại bản Điều khoản sử dụng Website này một cách
        tự nguyện.
      </li>
    </ul>

    <h3>Sử dụng dịch vụ của chúng tôi</h3>

    <p>
      ED vận hành trên nền tảng đặt hàng thiết kế trực tuyến. Nhằm truy cập một
      số Dịch vụ, bạn có thể được yêu cầu đănh ký một tài khoản ED và cung cấp
      thông tin về bạn (như thông tin về chứng minh nhân thân hoặc địa chỉ liên
      lạc) như là một phần của quá trình đặt hàng, đăng ký hoặc sử dụng tiếp tục
      các Dịch vụ. Bạn có thể tìm hiểu quá trình giao dịch trên ExpressDesign.vn
      của chúng tôi.
    </p>
    <p>
      Bạn đồng ý rằng bất kỳ thông tin đăng ký nào bạn trao cho ED sẽ luôn chính
      xác, không mâu thuẫn với bất kỳ quy định bảo vệ dữ liệu nào. Bạn không
      được sử dụng tài khoản của người khác nếu không được phép. Bạn phải tự
      chịu trách nhiệm về hoạt động xảy ra trong tài khoản của mình và bạn phải
      bảo mật mật khẩu tài khoản của mình. Bạn phải thông báo cho ED ngay lập
      tức về bất kỳ vi phạm về bảo mật hoặc sử dụng trái phép tài khoản của bạn.
      ED sẽ không chịu trách nhiệm về bất kỳ thiệt hại do bất kỳ hành vi sử dụng
      trái phép tài khoản của bạn.
    </p>
    <p>
      Liên quan đến việc bạn sử dụng Dịch vụ, chúng tôi có thể gửi cho bạn các
      thông báo dịch vụ, thông báo quản trị và thông tin khác. Bạn có thể chọn
      không nhận một số thông báo này.
    </p>
    <p>
      Chúng tôi có quyền từ chối hoặc huỷ bỏ bất kỳ lệnh đặt nào cho dù đơn đặt
      hàng của bạn có được xác nhận và thanh toán hay không. Tuy nhiên, nếu có
      bất kỳ sai sót nào trong trường hợp giá không được hiển thị hoặc sai, theo
      các trường hợp khác nhau, chúng tôi sẽ liên hệ với bạn để được hướng dẫn
      hoặc hủy đơn đặt hàng.
    </p>

    <h3>Các quy định dịch vụ </h3>
    <p>
      Dịch vụ của chúng tôi cho phép bạn tải lên, đệ trình, lưu trữ, gửi hoặc
      nhận sản phẩm (“sản phẩm thiết kế”). Bạn giữ quyền sở hữu mọi quyền sở hữu
      trí tuệ mà bạn có đối với nội dung, sản phẩm thiết kế đó.
    </p>
    <p>
      Khi bạn tải lên, đệ trình, lưu trữ, gửi hoặc nhận nội dung đến hoặc qua
      Dịch vụ của chúng tôi, bạn cấp cho ED (và những người chúng tôi làm việc
      cùng) giấy phép sử dụng, lưu trữ, điều chỉnh, tạo các tác phẩm phái sinh
      (chẳng hạn như tái tạo sản phẩm thiết kế, đồ lại logo, biểu tượng... hoặc
      những thay đổi khác mà chúng tôi thực hiện để sản phẩm của bạn tốt hơn với
      Dịch vụ của chúng tôi), hiển thị và phân phối công khai nội dung đó. Những
      quyền bạn cấp trong giấy phép này là nhằm phục vụ các mục đích quảng bá và
      cải thiện Dịch vụ của chúng tôi và để phát triển những dịch vụ mới.
    </p>
    <p>
      Bạn có thể tìm thêm thông tin về cách ED sử dụng và lưu trữ nội dung trong
      chính sách về sự riêng tư hoặc các điều khoản bổ sung. Nếu bạn gửi phản
      hồi hoặc đề xuất về Dịch vụ của chúng tôi, chúng tôi có thể sử dụng phản
      hồi hoặc đề xuất của bạn mà không phải chịu bất cứ nghĩa vụ nào.
    </p>
    <p>
      Tất cả các quyền sở hữu trí tuệ (đã đăng ký hay không), tất cả các nội
      dung, hình ảnh, âm thanh, lập trình phần mềm, mã nguồn và phần mềm cơ bản
      về Dịch vụ đều là tài sản của chúng tôi. Toàn bộ nội dung được bảo vệ theo
      luật bản quyền và các công ước quốc tế của Việt Nam. Bản quyền đều được
      bảo lưu.
    </p>
    <p>
      Bạn đồng ý không tham gia vào bất kỳ hoạt động trái phép. Ví dụ như: Can
      thiệp, xâm phạm toàn vẹn hệ thống hoặc bảo mật hoặc giải mã bất kỳ sự
      truyền tải nào đến hoặc từ các máy chủ; Tải lên dữ liệu không an toàn,
      phầm mềm độc hại, vi-rút (virus) hoặc các phần mềm khác không hợp lệ thông
      qua Dịch vụ; Mạo nhận người khác, gian lận, giấu hoặc cố che giấu danh
      tính của bạn.
    </p>
    <p>
      Chúng tôi có thể thay đổi Dịch vụ mà không cần thông báo trước; Ngừng cung
      cấp Dịch vụ hoặc các tính năng của Dịch vụ cho Người sử dụng; Hoặc tạo ra
      các giới hạn sử dụng cho Dịch vụ. Chúng tôi có thể tạm thời hoặc chấm dứt
      hoặc tạm dừng việc bạn truy cập vào Dịch vụ mà không có thông báo và trách
      nhiệm pháp lý vì bất kỳ lý do gì, bao gồm nếu theo quyết định của chúng
      tôi khi bạn vi phạm bất kỳ điều khoản nào của Thỏa thuận này hoặc không có
      lý do.
    </p>
    <p>
      Nếu tài khoản của bạn bị chấm dứt vì bất kỳ lý do nào, bạn phải có sự cho
      phép bằng văn bản từ ED trước khi thiết lập một tài khoản khác. Nếu bạn cố
      gắng thiết lập một tài khoản khác mà không có sự cho phép của ED, ED có
      thể cấm bạn vĩnh viễn khỏi Dịch vụ.
    </p>

    <h3>Bảo vệ sự riêng tư và bản quyền</h3>
    <p>
      Chúng tôi quan tâm đến quyền riêng tư của Người sử dụng. Bạn hiểu rằng
      bằng cách sử dụng Dịch vụ của chúng tôi, bạn đồng ý rằng ED có thể những
      sử dụng dữ liệu đó theo chính sách của chúng tôi về quyền riêng tư trong
      Chính sách Bảo mật. Chính sách giải thích cách chúng tôi xử lý dữ liệu cá
      nhân của bạn và bảo vệ sự riêng tư của bạn khi bạn sử dụng Dịch vụ.
    </p>
    <p>
      Nếu bạn cho rằng ai đó đang vi phạm vào quyền riêng tư của bạn và bạn muốn
      thông báo cho chúng tôi, bạn có thể liên hệ trực tiếp tới Trung tâm trợ
      giúp của chúng tôi.
    </p>
    <p>
      Tuy nhiên, chúng tôi không thể đảm bảo rằng bên thứ ba trái phép sẽ không
      bao giờ thâm nhập vào các biện pháp bảo mật của chúng tôi hoặc sử dụng
      thông tin cá nhân của bạn cho các mục đích không đúng. Bạn thừa nhận rằng
      bạn tự chịu mọi rủi ro khi cung cấp thông tin cá nhân của bạn.
    </p>
    <p>
      Dịch vụ của ED cung cấp các sản phẩm liên quan tới Sở hữu trí tuệ và vấn
      đề Bản quyền vì thế khi tham gia dịch vụ của ED bạn đồng ý với các bước
      hướng dẫn sử dụng Dịch vụ, các giới hạn về trách nhiệm và quyền lợi như
      quyền sở hữu sản phẩm, trách nhiệm chia sẻ thông tin,... ED cung cấp các
      dịch vụ được nhà nước Việt Nam bảo hộ, tuân thủ theo luật Sở hữu trí tuệ
      và luật Bản quyền của Việt Nam.
    </p>
    <p>
      ED cam kết giữ bảo mật thông tin (bao gồm thông tin cá nhân, nội dung, chi
      phí,...) trong các Giao dịch với bạn. Nếu bạn đại diện cho một doanh
      nghiệp hoặc tổ chức, bạn đồng ý có trách nhiệm song phương với ED trong
      việc bảo mật thông tin Giao dịch cho doanh nghiệp hoặc tổ chức của bạn.
    </p>

    <h3>Liên kết của bên thứ ba</h3>
    <p>
      Dịch vụ có thể chứa các liên kết đến các trang web, nhà quảng cáo, dịch
      vụ, phiếu mua hàng, giảm giá hoặc hoạt động khác không phải do ED sở hữu
      hoặc kiểm soát. Đội ngũ phát triển ED có sự kiểm soát chặt chẽ tới sự an
      toàn của bạn khi giới thiệu bạn sử dụng các liên kết của bên thứ ba. Các
      dịch vụ của ED tách biệt và độc lập với các bên thứ ba và nằm ngoài Chính
      sách bảo mật thông tin của ED, bạn cần cân nhắc trong việc cung cấp các
      thông tin cá nhân cho các liên kết này. ED không xác nhận hoặc thừa nhận
      bất kỳ trách nhiệm nào đối với bất kỳ trang web, thông tin, tài liệu, sản
      phẩm hay dịch vụ của bên thứ ba.
    </p>
    <p>
      Nếu bạn truy cập trang web của bên thứ ba từ Dịch vụ, bạn hiểu rằng bạn
      chấp nhận Thỏa thuận này và Chính sách Bảo mật của ED không áp dụng cho
      việc bạn sử dụng các trang web đó. Ngoài ra, bạn đồng ý rằng ED sẽ không
      chịu trách nhiệm về bất kỳ mất mát hoặc thiệt hại liên quan đến các giao
      dịch của bạn với các dịch vụ của bên thứ ba.
    </p>

    <h3>Việc sử dụng Dịch vụ cho doanh nghiệp</h3>
    <p>
      Nếu bạn đang sử dụng Dịch vụ của chúng tôi thay mặt cho doanh nghiệp, thì
      doanh nghiệp đó chấp nhận các điều khoản này. Doanh nghiệp đó sẽ bồi hoàn
      và giữ cho ED cũng như các công ty liên kết, cán bộ, người đại diện và
      nhân viên của ED không bị tổn hại đối với bất kỳ khiếu nại, khiếu kiện
      hoặc tố tụng nào nảy sinh từ hoặc có liên quan đến việc sử dụng Dịch vụ;
      Hoặc vi phạm các điều khoản này, bao gồm cả bất kỳ trách nhiệm pháp lý
      hoặc chi phí nào phát sinh từ các khiếu nại, tổn thất, thiệt hại, khiếu
      kiện, phán quyết, chi phí tố tụng và tiền phí luật sư.
    </p>
    <h3>Tuyên bố từ chối trách nhiệm của chúng tôi</h3>
    <p>
      Chúng tôi đặc biệt chú trọng tính hợp lý về mặt thương mại và chúng tôi hy
      vọng rằng bạn sẽ thích thú khi sử dụng các Dịch vụ ED. Tuy nhiên, có một
      số điều khoản nhất định mà chúng tôi không hứa hẹn về Dịch vụ của mình.
    </p>
    <p>
      Đội ngũ phát triển ED và người cấp phép của ED không bảo đảm rằng dịch vụ
      sẽ đáp ứng yêu cầu của bạn; Rằng dịch vụ sẽ không bị gián đoạn hoặc không
      an toàn; Rằng bất kỳ lỗi hoặc lỗi nào sẽ được sửa chữa; Hoặc dịch vụ không
      có virus hoặc các thành phần có hại khác. Bất kỳ nội dung nào được tải
      xuống hoặc thu được bằng cách khác thông qua việc sử dụng Dịch vụ đều chịu
      rủi ro và bạn tự chịu trách nhiệm cho bất kỳ hư hỏng nào đối với hệ thống
      máy tính hoặc thiết bị di động của bạn hoặc mất dữ liệu do tải xuống hoặc
      sử dụng dịch vụ của bạn.
    </p>
    <p>
      Các dịch vụ của ED chỉ giới hạn quyền lợi và trách nhiệm với duy nhất với
      bạn (1 khách hàng) trong mỗi một Giao dịch, ED không chịu trách nhiệm
      trong việc bạn chia sẻ các nội dung tới các bên thứ 3, tuy nhiên bạn phải
      chịu hoàn toàn trách nhiệm về pháp lý như Sở hữu trí tuệ, Bản quyền, bí
      mật kinh doanh,... khi chia sẻ các thông tin, nội dung của Giao dịch tới
      bên thứ ba.
    </p>
    <p>
      ED không bảo đảm hoặc chịu trách nhiệm đối với bất kỳ sản phẩm hay dịch vụ
      nào được quảng cáo hoặc cung cấp bởi một bên thứ ba thông qua dịch vụ ED;
      Hoặc bất kỳ trang web hoặc dịch vụ có liên kết nào và ED sẽ không phải là
      một bên tham gia theo bất kỳ hình thức nào. Chúng tôi không theo dõi bất
      kỳ giao dịch nào giữa bạn và bên thứ ba cung cấp các sản phẩm hoặc dịch
      vụ.
    </p>
    <p>
      Vui lòng liên hệ với chúng tôi tại{" "}
      <a href="mailto:support@expressdesign.vn">support@expressdesign.vn</a> nếu
      bạn có bất kỳ thắc mắc nào liên quan đến Thỏa thuận này.
    </p>
  </div>,
];

export default Terms;



// WEBPACK FOOTER //
// ./src/routes/StaticPages/components/Terms.tsx